import { jsx as n } from "react/jsx-runtime";
import { useFormContext as $, Controller as k } from "react-hook-form";
import { NeuDatePicker as P } from "@hcahealthcaredpx/neutron-react";
const B = ({
  name: o,
  labelHidden: u = !1,
  kind: m = "single",
  today: f = !0,
  disabledDates: g = [],
  disabledDays: p = [0, 6],
  calendar: s = !1,
  triggerValidationOnChange: v = !1,
  ...h
}) => {
  var c;
  const {
    control: C,
    trigger: a,
    formState: { errors: t }
  } = $(), i = (c = t == null ? void 0 : t[o]) == null ? void 0 : c.message, x = (r) => {
    const e = /^(\d{2})\/(\d{2})\/(\d{4})$/, l = r == null ? void 0 : r.match(e);
    if (l) {
      const [d, D, F, N] = l;
      return `${N}-${D}-${F}`;
    }
    return r;
  };
  return /* @__PURE__ */ n(
    k,
    {
      name: o,
      control: C,
      render: ({ field: r }) => /* @__PURE__ */ n(
        "div",
        {
          className: "w-100",
          onClick: (e) => {
            s && (e.stopPropagation(), e.preventDefault()), v && a(o);
          },
          children: /* @__PURE__ */ n(
            P,
            {
              labelHidden: u,
              kind: m,
              today: f,
              disabledDates: g,
              disabledDays: p,
              calendar: s,
              value: x(r.value),
              onNeuChange: (e) => r.onChange(e.value),
              onNeuBlur: () => a(o),
              invalid: i,
              error: !!i,
              ...h
            }
          )
        }
      )
    }
  );
};
export {
  B as F
};
